import {t} from 'i18next';
import {z} from 'zod';
import {ISelectItem} from '../../../shared/types';

export enum ProjectFieldDataType {
  'BIT' = 'BIT',
  'DATE' = 'Date',
  'DATETIME' = 'DATETIME',
  'INT' = 'INT',
  'MASTERDOCCODE' = 'Master DOCCODE',
  'NVARCHAR' = 'NVARCHAR',
  'TIME' = 'Time',
}

export const projectFieldSchema = () =>
  z.object({
    fieldName: z
      .string()
      .trim()
      .min(1, {
        message: t(
          'manageProjectField.addProjectField.errors.fieldNameRequired'
        ),
      }),
    fieldLabel: z.string().trim().optional(),
    fieldDesc: z.string().trim(),
    isDerived: z.boolean(),
    isEditable: z.boolean(),
    isMultiValue: z.boolean(),
    isSearchable: z.boolean(),
    isTallyable: z.boolean(),
    selectedFieldGroup: z.object<ISelectItem>(),
    selectedFieldClassfication: z.object<ISelectItem>(),
    selectedFieldType: z.object<ISelectItem>(),
    selectedFieldLength: z.object<ISelectItem>(),
    selectedFieldDerived: z.object<ISelectItem>(),
    isCustomField: z.boolean().optional().default(false),
    canBeSearched: z.boolean().optional().default(false),
  });

export type ProjectFieldForm = z.infer<ReturnType<typeof projectFieldSchema>>;
